<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Capacitor } from '@capacitor/core'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const { t } = useI18n()
const STORAGE_KEY = 'pavemi_cookie_consent'
const visible = ref(false)

onMounted(() => {
  if (Capacitor.isNativePlatform()) return
  if (typeof localStorage === 'undefined') return
  if (localStorage.getItem(STORAGE_KEY)) return
  visible.value = true
})

function accept() {
  try { localStorage.setItem(STORAGE_KEY, '1') } catch { /* private mode */ }
  visible.value = false
}
</script>

<template>
  <Transition name="pop">
    <div
      v-if="visible"
      class="fixed bottom-0 inset-x-0 z-[100] bg-white dark:bg-graphite-900 border-t border-slate-200 dark:border-graphite-800 shadow-2xl pb-[max(env(safe-area-inset-bottom,0px),0.5rem)]"
      role="region"
      :aria-label="t('common.cookies.region_label')"
    >
      <div class="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <p class="text-sm text-slate-700 dark:text-graphite-200 flex-1">
          <span class="mr-1.5" aria-hidden="true">🍪</span>
          {{ t('common.cookies.message') }}
          <a href="/privacy" target="_blank" rel="noopener" class="text-brand-600 dark:text-brand-400 underline">{{ t('common.cookies.policy_link') }}</a>.
        </p>
        <div class="flex items-center gap-2 sm:flex-shrink-0">
          <button
            @click="accept"
            class="px-4 py-2 rounded-lg bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium transition"
          >
            {{ t('common.cookies.accept') }}
          </button>
          <button
            @click="accept"
            class="p-2 text-slate-500 hover:text-slate-600 dark:text-graphite-300 dark:hover:text-graphite-300"
            :aria-label="t('common.cookies.close_label')"
          >
            <XMarkIcon class="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
